import { createReducer } from '@reduxjs/toolkit';
import { setPayload } from '../actions/indicatorPayload';

const initialState: any = {}

const indicatorPayloadReducer = createReducer(initialState, builder => {
    builder
        .addCase(setPayload, (state, action) => {
            state.payload = action.payload;
        })
})

export default indicatorPayloadReducer;